import React from 'react'
import Navbar from '../components/utilComponents/navbar'
import Footer from '../components/utilComponents/footer'
import { Outlet } from 'react-router-dom'

const Layout = () => {
  return (
    <div className='overflow-hidden'>
    <Navbar/>
    <Outlet/>
    <Footer/>
    </div>
  )
}

export default Layout